import {Button} from "@mantine/core";
import {IProtocolStep, IProtocolStepKind} from "@/protocols/types/protocol.ts";

interface TimerButtonProps {
    step: IProtocolStep;
    isCounting: boolean;
    onStart: (duration: number, description: string) => void;
}

/**
 * Renders a Start/Restart button for timed steps.
 * Shows for steps with duration or stim events with treatment duration.
 */
export const TimerButton: React.FC<TimerButtonProps> = ({
    step,
    isCounting,
    onStart,
}) => {
    let duration: number | undefined;

    if ("duration" in step) {
        duration = step.duration;
    } else if (step.kind === IProtocolStepKind.STIM_EVENT) {
        duration = step.stimMetadata?.treatmentDurationSec || 0;
    }

    if (duration === undefined || duration === 0) {
        return <Box/>;
    }

    const handleClick = () => {
        onStart(duration!, step.name);
    };

    return (
        <Button disabled={isCounting || duration === 0} size={"xs"} onClick={handleClick}>
            {!step.startTime ? "Start" : "Restart"}
        </Button>
    );
};

// Need to import Box for the fallback case
import {Box} from "@mantine/core";
